"use client";
import React from "react";
import { useForm } from "react-hook-form";

const CareerForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    console.log(data);
    // You can handle form submission here
  };

  return (
    <section className="bg-white dark:bg-gray-900" suppressHydrationWarning>
      <div className="py-8 lg:py-16 px-4 mx-auto max-w-screen-md">
        <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-center text-gray-900 dark:text-white">
          Career
        </h2>
        <p className="mb-8 lg:mb-16 font-light text-center text-gray-500 dark:text-gray-400 sm:text-xl">
          Join our team and be a part of our growth.
        </p>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
          <div className="flex flex-col lg:flex-row lg:gap-5">
            <div className="lg:w-1/2">
              <label
                htmlFor="name"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                Name
              </label>
              <input
                {...register("name", { required: true })}
                id="name"
                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                placeholder="Your name"
              />
              {errors.name && (
                <p className="text-red-500 text-sm">This field is required</p>
              )}
            </div>
            <div className="lg:w-1/2">
              <label
                htmlFor="email"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                Email
              </label>
              <input
                {...register("email", { required: true })}
                type="email"
                id="email"
                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                placeholder="name@domain.com"
              />
              {errors.email && (
                <p className="text-red-500 text-sm">This field is required</p>
              )}
            </div>
          </div>
          <div className="flex flex-col lg:flex-row lg:gap-5">
            <div className="lg:w-1/2">
              <label
                htmlFor="mobile"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                Mobile
              </label>
              <input
                {...register("mobile", { required: true })}
                type="tel"
                id="mobile"
                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                placeholder="Your mobile number"
              />
              {errors.mobile && (
                <p className="text-red-500 text-sm">This field is required</p>
              )}
            </div>
            <div className="lg:w-1/2">
              <label
                htmlFor="post"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                Apply for Post
              </label>
              <input
                {...register("post", { required: true })}
                id="post"
                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                placeholder="Position you're applying for"
              />
              {errors.post && (
                <p className="text-red-500 text-sm">This field is required</p>
              )}
            </div>
          </div>
          <div className="flex flex-col lg:flex-row lg:gap-5">
            <div className="lg:w-1/2">
              <label
                htmlFor="qualification"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                Educational Qualification
              </label>
              <input
                {...register("qualification", { required: true })}
                id="qualification"
                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                placeholder="Your qualification"
              />
              {errors.qualification && (
                <p className="text-red-500 text-sm">This field is required</p>
              )}
            </div>
            <div className="lg:w-1/2">
              <label
                htmlFor="salary"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                Expected Salary
              </label>
              <input
                {...register("salary", { required: true })}
                id="salary"
                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
                placeholder="Your expected salary"
              />
              {errors.salary && (
                <p className="text-red-500 text-sm">This field is required</p>
              )}
            </div>
          </div>
          <div>
            <label
              htmlFor="joiningDate"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
            >
              When Can You Join
            </label>
            <input
              {...register("joiningDate", { required: true })}
              type="date"
              id="joiningDate"
              className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:shadow-sm-light"
            />
            {errors.joiningDate && (
              <p className="text-red-500 text-sm">This field is required</p>
            )}
          </div>
          <button
            type="submit"
            className="py-3 px-5 text-sm font-medium text-center text-white bg-primary-700 rounded-lg sm:w-fit hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
          >
            Submit Application
          </button>
        </form>
      </div>
    </section>
  );
};

export default CareerForm;
